import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets window scroll position to the top on every pathname change.
 * Mounted once inside <BrowserRouter> so it applies to every route.
 *
 * Honors:
 *   - Hash fragments (#id) — does not scroll to top so anchor-jumping
 *     works normally.
 *   - "Back" navigation — browsers restore scroll position on POP
 *     navigation types, so we skip in that case.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let anchors handle themselves
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
